import { createApp, routerLink, routerView } from '@digitalbranch/app'

import {
  uiIcon,
  uiIconButton,
  uiRipple,
  uiPage,
  uiGrid,
  uiHeading,
  uiParagraph,
  uiCard,
  uiCardContent,
  uiCardImage,
  uiButton,
} from '@digitalbranch/scaffold-ui'
import { router } from './routes'
import { main } from './components'

const icons = [
  'dark_mode',
  'light_mode',
  'menu',
  'menu_open',
  'home_pin',
  'person',
  'alternate_email',
  'workspaces',
  'open_in_new'
]

createApp({
  el: '#app',
  provide: {
    icons,
  },
  components: {
    routerLink,
    routerView,
    main,
    uiIcon,
    uiIconButton,
    uiRipple,
    uiPage,
    uiGrid,
    uiHeading,
    uiParagraph,
    uiCard,
    uiCardContent,
    uiCardImage,
    uiButton
  },
  router,
})
